(function(angular) {
    'use strict';

    var app = angular.module('asDemandMgr');

    app.service('InImageTypeXService', [
        '$http',
        '$q',
        function($http, $q) {
                this.getDefaultOptions = function() {
                    return {
						creativeWidth: '300',
						creativeHeight: '600',
						minWidth: 150,
						maxWidth: "100%",
						minHeight: 300,
						maxHeight: 600,
						closeActionTime: -1,
                    };

                };

            this.generateContent = function(scope, options){
                var template = ``;
                return template;
            };






        },
    ]);
})(window.angular);
